<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form-model layout="inline" :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-model-item :label="$t('角色名称')">
              <a-input v-model="queryParams.name" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('应用')">
              <a-select v-model="queryParams.appId" :options="appOptions" allowClear />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item>
              <a-button type="primary" @click="handleRefresh(true)">{{ $t('查询') }}</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <a-button type="primary" @click="handleAdd">{{ $t('新增') }}</a-button>
    <a-table rowKey="id" :pagination="pagination" :columns="columns" :dataSource="roles" @change="handleTableChange">
      <div slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">{{ $t('编辑') }}</a>    
        <a-divider type="vertical" />
        <a @click="handleEditMenu(record)">{{ $t('权限') }}</a>    
        <a-divider type="vertical" />
        <a-popconfirm :title="$t('确认删除吗？')" @confirm="handleDelete(record)">
          <a style="color: red;">{{ $t('删除') }}</a>
        </a-popconfirm>
      </div>
    </a-table>
    <RoleEditModal ref="edit" @ok="handleRefresh" />
    <RoleEditMenuModal ref="menu" @ok="handleRefresh" />
  </a-card>
</template>
<script>
import { getRoleList, removeRole } from '@/api/system/role'
import RoleEditModal from './modals/RoleEditModal.vue'
import RoleEditMenuModal from './modals/RoleEditMenuModal.vue'
import { getAppListForCurrentUser } from '@/api/app/app'

export default {
  components: {
    RoleEditModal,
    RoleEditMenuModal
  },
  data() {
    return {
      queryParams: {},
      roles: [],
      appOptions: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showTotal: total => this.$t('共n条数据', [total])
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('角色名称'),
          dataIndex: 'name',
          width: 200
        },
        {
          title: this.$t('角色标识'),
          dataIndex: 'key'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          width: 300,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  mounted() {
    this.handleRefresh()
    this.loadOptions()
  },
  methods: {
    handleRefresh(toFirstPage = false) {
      this.loadTableData({ pageNum: toFirstPage ? 1 : this.pagination.current, pageSize: this.pagination.pageSize, ...this.queryParams })
    },
    handleTableChange(page) {
      if (page.current == this.pagination.current) {
        return
      }
      this.loadTableData({ pageNum: page.current, pageSize: page.pageSize, ...this.queryParams })
    },
    loadTableData(params) {
      getRoleList({ ...params }).then(res => {
        if (res.code === 0) {
          this.pagination.current = res.data.pageNum
          this.pagination.total = res.data.total
          this.roles = res.data.items
        } else {
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      })
    },
    loadOptions() {
      getAppListForCurrentUser().then(res => {
        this.appOptions = res.data?.map(e => ({ label: e.name, value: e.id })) ?? []
      })
    },
    handleAdd() {
      this.$refs.edit.show()
    },
    handleEdit(record) {
      this.$refs.edit.show(record)
    },
    handleEditMenu(record) {
      this.$refs.menu.show(record)
    },
    handleDelete(record) {
      removeRole([record.id]).then(res => {
        if (res.code === 0) {
          this.handleRefresh()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>
<style lang="less" module>
.container {
  height: 100%;
  padding: 20px;
}
</style>